// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"3bffce61","977":"61403f6f"}[chunkId] + ".chunk.js";
};